<app-header></app-header>
<app-lateral-buttons></app-lateral-buttons>
<app-contacto></app-contacto>
<app-footer></app-footer>
